<template> 
     <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
        message="Enter a name. Select the Room Type(s) this Template will be associaed with. Description and Instruction are optional. Click Save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div class="w-100 table-responsive table-fix-head overflow-y--1" v-if="array_options.room_type_id.length" style="margin-top:20px;">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <th class="header-item-manual" v-for="(item, i) in room_type_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in room_types" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checked${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`checked${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td v-html="item.name"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "rest_api",
        "notyf",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return {
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
            room_type_table_headers: Resources.room_type_table_headers,
        }
    },

    methods: {
        form_submit_local() {
            const room_types = this.room_types.filter( item => item.checked).map(item => item.id)
            if (room_types.length) {
                this.form_data.room_type_id = room_types
                this.form_submit();
                return true;
            }
            this.notyf.error('Room Type is required')
            return false;
        }
    },

    mounted() {

    },

    computed: {
        room_types() {
            return [... this.array_options.room_type_id]
        },
    },

    
    
}
</script>